import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import { Button, Group, Input, Label, NumberField } from "react-aria-components";

import { cn } from "@/lib/utils";

interface NumInputSeparatedProps {
	label?: string;
	currency?: string;
	className?: string;
	value: string;
	onChange: (value: string) => void;
	defaultValue?: number;
	placeholder?: string;
}

export function NumInputSeparated({
	label = "",
	currency,
	value,
	onChange,
	placeholder = "Enter amount",
	...props
}: NumInputSeparatedProps) {
	const numericValue = value ? parseFloat(value) : undefined;

	const formatOptions = currency
		? {
				style: "currency" as const,
				currency,
				currencySign: "accounting" as const
			}
		: {};

	return (
		<NumberField
			value={numericValue}
			onChange={val => onChange(val?.toString() ?? "")}
			formatOptions={formatOptions}
		>
			<div className="*:not-first:mt-2">
				<Label className={
					cn("text-foreground text-sm font-medium", label && "mb-2")
				}
				>
					{label}
				</Label>
				<Group className="border-input  focus-within:ring-ring focus-within:ring-1  doutline-none data-focus-within:border-ring data-focus-within:ring-ring/50 data-focus-within:has-aria-invalid:ring-destructive/20 dark:data-focus-within:has-aria-invalid:ring-destructive/40 data-focus-within:has-aria-invalid:border-destructive relative inline-flex h-12 w-full items-center overflow-hidden rounded-md border text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] data-disabled:opacity-50 data-focus-within:ring-[3px]">
					<Input
						placeholder={placeholder}
						className="bg-background focus-visible:outline-transparent  text-foreground flex-1 px-3 py-2 tabular-nums"
						{...props}
					/>
					<div className="flex h-[calc(100%+2px)] flex-col">
						<Button
							slot="increment"
							className="border-input bg-background text-muted-foreground/80 hover:bg-accent hover:text-foreground -me-px flex h-1/2 w-6 flex-1 items-center justify-center border text-sm transition-[color,box-shadow] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50"
						>
							<ChevronUpIcon size={12} aria-hidden="true" />
						</Button>
						<Button
							slot="decrement"
							className="border-input bg-background text-muted-foreground/80 hover:bg-accent hover:text-foreground -me-px -mt-px flex h-1/2 w-6 flex-1 items-center justify-center border text-sm transition-[color,box-shadow] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50"
						>
							<ChevronDownIcon size={12} aria-hidden="true" />
						</Button>
					</div>
				</Group>
			</div>
		</NumberField>
	);
}
